const OVERLAY_ID = 'js-loading-overlay';

export function showOverlay() {
  const overlay = document.getElementById(OVERLAY_ID);
  if (overlay) {
    overlay.classList.remove('is-hidden');
    document.documentElement.style.overflow = 'hidden';
  }
}

export function hideOverlay() {
  const overlay = document.getElementById(OVERLAY_ID);
  if (overlay) {
    overlay.classList.add('is-hidden');
    document.documentElement.style.overflow = '';
  }
}

// 内容のある最初の .{errormClass} 要素へスムーズスクロール
export function scrollToFirstError(errormClass) {
  const errors = Array.from(document.querySelectorAll('.' + errormClass))
    .filter(el => el.innerHTML.trim() !== '');
  if (errors.length > 0) {
    errors[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
